import { render, staticRenderFns } from "./CookieModal.vue?vue&type=template&id=38cba26c"
import script from "./CookieModal.vue?vue&type=script&lang=js"
export * from "./CookieModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports